import Div from "@jumbo/shared/Div/Div";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import {
  Autocomplete,
  Box,
  Button,
  InputAdornment,
  Pagination,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";

import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getAllSales, getAllShopOrdersSales } from "app/redux/actions/salesAction";
import { getPortListNoPerm } from "app/services/apis/ListApi/portListNoPerm";
import { getOrderNoList } from "app/services/apis/ListApi/orderNoList";
import { getFinishItemNameList, getItemNameList } from "app/services/apis/ListApi/itemNameList";
import { downloadSalesListReport, downloadShopOrderSalesReport } from "app/services/apis/ReportApis/Sales/SalesListReport";
import NormalOrderSalesTable from "./normalOrderSalesTable";
import ShopOrderSalesTable from "./shopOrderSalesTable";

export default function ListSales() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [resetAutocomplete, setResetAutocomplete] = useState(false);
  const [inputs, setInputs] = useState({});
  const [orderNoList, setOrderNoList] = useState([]);
  const [portNoNameList, setPortNoNameList] = useState([]);
  const [itemNameList, setItemNameList] = useState([]);
  const [tabValue, setTabValue] = useState("one");

  const { allSales, allShopOrderSales, TotalPage, loading } = useSelector((state) => state.salesReducer);

  const handleSearch = (value) => {
    setPage(1);
    if (tabValue == "one") {
      dispatch(getAllSales(value, "", 1));
    } else {
      dispatch(getAllShopOrdersSales(value, "", 1));
    }
  };

  const handleFilter = () => {
    setPage(1);
    if (tabValue == "one") {
      dispatch(getAllSales("", inputs, 1));
    } else {
      dispatch(getAllShopOrdersSales("", inputs, 1));
    }
  };

  const handleClearFilter = () => {
    setPage(1);
    if (tabValue == "one") {
      dispatch(getAllSales("", "", 1));
    } else {
      dispatch(getAllShopOrdersSales("", "", 1));
    }
    setInputs({});
    setResetAutocomplete((prev) => !prev);
  };

  useEffect(() => {
    (async () => {
      // dispatch(getAllSales("", "", 1));
      setPortNoNameList(await getPortListNoPerm());
      if (tabValue === "one") {
        setOrderNoList(await getOrderNoList());
        setItemNameList(await getItemNameList());
      }else{
        setOrderNoList(await getOrderNoList("shop"));
        setItemNameList(await getFinishItemNameList());
      }
    })();
  }, []);

  return (
    <Div sx={{ mt: -2 }}>
      <Div sx={{ mt: -4 }}>
        <Typography variant="h1">Sales</Typography>
        <Div
          sx={{
            display: "flex",
            justifyContent: "left",
            gap: 3,
            mt: 3,
            width: "100%",
            //   flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <Div sx={{ width: "23%" }}>
            <Typography variant="h5">Port No & Name</Typography>
            <Autocomplete
              key={resetAutocomplete ? "reset1" : "normal1"}
              size="small"
              id="tags-standard"
              options={portNoNameList || []}
              value={inputs.order_port_no_and_name}
              getOptionLabel={(option) => option}
              onChange={(e, newValue) => {
                setInputs((values) => ({
                  ...values,
                  order_port_no_and_name: newValue ? newValue : null,
                }));
              }}
              renderOption={(props, option) => (
                <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
                  {option}
                </Box>
              )}
              renderInput={(params) => <TextField {...params} variant="outlined" />}
            />
          </Div>
          <Div sx={{ width: "23%" }}>
            <Typography variant="h5">Order No</Typography>
            <Autocomplete
              key={resetAutocomplete ? "reset1" : "normal1"}
              size="small"
              id="tags-standard"
              options={orderNoList || []}
              value={inputs.order_no}
              getOptionLabel={(option) => option}
              onChange={(e, newValue) => {
                setInputs((values) => ({
                  ...values,
                  order_no: newValue ? newValue : null,
                }));
              }}
              renderOption={(props, option) => (
                <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
                  {option}
                </Box>
              )}
              renderInput={(params) => <TextField {...params} variant="outlined" />}
            />
          </Div>
          <Div sx={{ width: "23%" }}>
            <Typography variant="h5">Item Name</Typography>
            <Autocomplete
              key={resetAutocomplete ? "reset1" : "normal1"}
              size="small"
              id="tags-standard"
              options={itemNameList || []}
              value={inputs.order_item_name}
              getOptionLabel={(option) => option}
              onChange={(e, newValue) => {
                setInputs((values) => ({
                  ...values,
                  order_item_name: newValue ? newValue : null,
                }));
              }}
              renderOption={(props, option) => (
                <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
                  {option}
                </Box>
              )}
              renderInput={(params) => <TextField {...params} variant="outlined" />}
            />
          </Div>
          <Button variant="outlined" sx={{ mt: 2.5 }} onClick={handleFilter}>
            Apply
          </Button>
          <Button variant="outlined" sx={{ mt: 2.5 }} onClick={handleClearFilter}>
            Clear
          </Button>
        </Div>
        <Div
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TextField
            size="small"
            id="search"
            type="search"
            label="Search"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              handleSearch(e.target.value);
            }}
            sx={{ width: 300, mb: 5, mt: 4 }}
            InputProps={{
              endAdornment: (
                <Div sx={{ cursor: "pointer" }}>
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                </Div>
              ),
            }}
          />
          <Button
            variant="contained"
            disabled={allSales?.length == 0}
            onClick={async () => {
              if (tabValue == "one") {
                const data = await downloadSalesListReport(inputs);
                window.open(data);
              } else {
                const data = await downloadShopOrderSalesReport(inputs);
                window.open(data);
              }
            }}
          >
            Export CSV
          </Button>
        </Div>
      </Div>

      {/* tab */}
      <>
        <Tabs
          sx={{ mb: 2 }}
          value={tabValue}
          onChange={(e, value) => {
            setTabValue(value);
            setPage(1);
            setInputs({});
            setResetAutocomplete((prev) => !prev);
          }}
          textColor="primary"
          indicatorColor="primary"
          aria-label="secondary tabs example"
        >
          <Tab value="one" label="Normal Order" />
          <Tab value="two" label="Shop Order" />
        </Tabs>

        {/* Tables import */}
        {tabValue == "one" ? (
          <NormalOrderSalesTable searchTerm={searchTerm} setPage={setPage} page={page} inputs={inputs} />
        ) : (
          <ShopOrderSalesTable searchTerm={searchTerm} setPage={setPage} page={page} inputs={inputs} />
        )}
      </>
    </Div>
  );
}
